/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Attachment_FailedInputs */



/**
* | output |
* | --- |
* | "That file was not uploaded. Try again." |
*
* @param {Chat_Attachment_FailedInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const chat_attachment_failed = /** @type {((inputs?: Chat_Attachment_FailedInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Attachment_FailedInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Dat bestand is niet geüpload. Probeer het opnieuw.")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Ce fichier n'a pas été envoyé. Réessayez.")
	return /** @type {LocalizedString} */ ("That file was not uploaded. Try again.")
});